import { useAppDispatch } from "app/hooks";
import { resetLayerVisibility } from "features/krpano/details-slice";
import { setCurrentField } from "features/panorama/details-slice";
import { useEffect } from "react";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

type UseCurrentField = (krpanoFeaturesReady: boolean) => void;

/**
 * # Listen for `skin_loadscene` actions dispatching the custom event `krpano__scene_change`
 *
 */
export const useCurrentField: UseCurrentField = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const sceneChangeHandler = (
      event: WindowEventMap["krpano__scene_change"]
    ) => {
      if (
        notNullNorUndefined(event.detail) &&
        notNullNorUndefined(event.detail.fid)
      ) {
        // Reset Layer visibility
        // IDEA: Instead, we could use the value of the layer visibility when
        // deciding whether or not to show the layer when it is created
        dispatch(resetLayerVisibility());
        // Update current field in Redux
        dispatch(
          setCurrentField({
            fieldId: event.detail.fid.toString(),
            forceReload: event.detail.forceReload,
          })
        );
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener("krpano__scene_change", sceneChangeHandler);
    return () => {
      window.removeEventListener("krpano__scene_change", sceneChangeHandler);
    };
  }, [dispatch]);
};
